/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import Layout from './components/Layout/Layout'
import './i18n'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals';

import themes from './themes';
 
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material'

const customization = {
    borderRadius: 10,
    fontFamily: "'Roboto', sans-serif",
    locale: "en",
    mode: "light",
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <BrowserRouter >
            <ThemeProvider theme={themes(customization)} >
                <Layout>
                    <App />
                </Layout>
            </ThemeProvider>
        </BrowserRouter>
    </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();